import axios from "axios";
var lzw = require("node-lzw");
import lzwCompress from 'lzwcompress';
import {Mutex, Semaphore, withTimeout} from 'async-mutex';
var LZMA = require("./src/lzma_worker.js")
import * as base64 from "byte-base64";
const pako = require('pako');

class SerialManager {
  constructor(eventHandlers = {}) {
    this.receivedState = null
    
    this.bufferedString = "";
    this.device = null;
    this.messageCounter = 0;
    this.ack = null;
    this.ackData = null
    
    this.onConnect = eventHandlers.onConnect || function() {}
    this.onConnectError = eventHandlers.onConnectError || function() {}
    this.onDisconnect = eventHandlers.onDisconnect || function() {}
    this.onDisconnectError = eventHandlers.onDisconnectError || function() {}
    this.onState = eventHandlers.onState || function() {}


    // locks
    this.writeMutex = new Mutex()
    

    // difference must equal base64 compression size
    this.packetSize = 63
    this.packetBodySize = 40 //packetSize - packetPrefixSize must = 4/3 * packetBodySize
    this.packetOverheadSize = 4
    this.commandWaitLength = 20
    this.readState = true

    this.modes = {
      GENERAL:          0x00,
      COMMAND_START:    0x01,
      COMMAND_CONTINUE: 0x02,
      COMMAND_END:      0x03,
      COMMAND_FULL:     0x04,
      FILE_START:       0x05,
      FILE_CONTINUE:    0x06,
      FILE_END:         0x07,
      STATE_REQUEST:    0x08,
    }

    this.connect = this.connect.bind(this);
    this.disconnect = this.disconnect.bind(this);
    this.write = this.write.bind(this);
  }

  async connect(packetSize, commandWaitLength, readState, configurationVal, interfaceVal ) {
    try {

      this.packetSize = packetSize
      this.commandWaitLength = commandWaitLength
      this.readState = readState

      this.device = await navigator.usb.requestDevice({ filters: [] });
      await this.device.open();
      // await this.device.reset();
      
      await this.device.selectConfiguration(configurationVal);
      await this.device.claimInterface(interfaceVal);
  
      const dataObject = await this.device.transferIn(1, 512);
      

      this.onConnect({ 
        type: 'onConnect', 
        data: { state: 1234} 
      })
      
      this.connected = true
      
      if (this.readState) {
        this.readData();
        this.requestState()
      }
      
    } catch (e) {
      this.onConnectError({
        type: 'onConnectError',
        data: {
          error: e
        }
      })
    }
  }

  async disconnect() {
    this.connected = false
    await new Promise((r) => setTimeout(r, 5000));
    this.device.close()
    this.onDisconnect({ 
      type: 'onDisconnect', 
      data: { } 
    })
  }

  async readData() {
    while (true && this.connected) {
      
      const readDataView = await this.read();
      const decodedData = await this.parse(readDataView);
      await this.handleMessage(decodedData, readDataView.byteLength);
    }
  }

  async handleMessage(data, byteLength) {
    if (byteLength !== 2) {
      this.bufferedString += data.substr(2);
      if (data.slice(-1) === "\n") {
        try {
          // console.log(1234)
          
          let current_data = JSON.parse(this.bufferedString);
          // console.log(current_data.ack)
          this.processMessage(current_data)
          this.bufferedString = ``;
        } catch (e) {
          var regex = /\d+/g;
          var matches = e.message.match(regex);
          // console.log(matches);
          if (matches !== null) {
            try {
              let message1 = JSON.parse(this.bufferedString.substring(0, matches[0]));
              this.processMessage(message1)
              let message2 = JSON.parse(this.bufferedString.substring(parseInt(matches[0]), this.bufferedString.length));
              this.processMessage(message2)
            } catch (err) {
              console.log("Retry error");
              console.log(err);
            }
          }

          this.bufferedString = ``;
          console.log(e);
        }
      }
    }
  }

  async processMessage(message) {
    if (message.ack !== undefined) {
      this.ack = parseInt(message.ack);
      this.ackData = message.data;
    }
  }

  async requestState() {
    while (true && this.connected) {
      const startMessage = ""
      const {error, ackData } = await this.write(startMessage, this.modes.STATE_REQUEST, 0, startMessage.length, 1)
      if (!error) {
          this.onState({ 
            type: 'onState', 
            data: { state: ackData.state} 
          })
      }
      await new Promise((r) => setTimeout(r, 5000));
    }

  }

  async sendCommand(command) {
    var commandArray = [command]
    var sentCommand = ""
    for (let i = 0; i < commandArray.length; i++) {
      const command = commandArray[i];
      const tokenArray = command.split(" ")
      for (let tokenIndex = 0; tokenIndex < tokenArray.length; tokenIndex++) {
        const token = tokenArray[tokenIndex]
    
  
        var fileMatch = /https/.exec(token);
        if (fileMatch) {
          const fileName = await this.sendFile(token)
          tokenArray[tokenIndex] = '/usr/share/allevi/files/' + fileName
        } else if (token === 'F1') {
          tokenArray[tokenIndex] = 'P1'
        }
      }
  
      sentCommand = tokenArray.join(" ")
      await this.sendMessage(tokenArray.join(" "))
      
    }

    return sentCommand
  }

  async parse(dataView) {
    const enc = new TextDecoder("utf-8");
    const decodedData = enc.decode(dataView.buffer);
    return decodedData;
  }

  async read() {
    const dataObject = await this.device.transferIn(1, 512);
    return dataObject.data;
  }

  async write(message, mode, sequence, messageLength, wait = 0) {
    
    const release = await this.writeMutex.acquire();
    

    try {
      
      await new Promise((r) => setTimeout(r, this.commandWaitLength));
      const enc = new TextEncoder(); // always utf-8
      const encodedData = enc.encode(String.fromCharCode(this.messageCounter + 32) + String.fromCharCode(mode + 32) + message + String.fromCharCode(0x03));
      const result = await this.device.transferOut(2, encodedData);
      

      let ackCounter = 0;
      let error = false
      // console.log(this.messageCounter)
      if (wait > 0) {
        while (this.ack !== this.messageCounter) {
          await new Promise((r) => setTimeout(r, 20));
          ackCounter += 1;
          if (ackCounter >= 1000) {
            console.log("Failed to wait for response");
            error = true;
            break;
          }
        }
      }
      

      // if (error && sequence <= 1) {
      //   return await this.write(message, mode, sequence+ 1, messageLength )
      // }

      
      if (this.messageCounter === 95) {
        this.messageCounter = 0;
      } else {
        this.messageCounter += 1;
      }
    
      this.ack = null;
      const currentAckData = this.ackData
      this.ackData = null
      
      release() 
      return {
        error,
        ackData: currentAckData
      }
      
    } catch (error) {
      release()  
    }
    
  }

  async sendFile(url) {
    console.log("[FILE] Starting to download file")
    const headers = new Headers();
    headers.append("Content-Type", "text/x.gcode");

    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers,
    };


    var response = await fetch(url, requestOptions)
    var responseBody = await response.text()  
    console.log("[FILE] Downloaded file successfully")
    

    console.log("[FILE] Starting to send file")
    // send start
    const startMessage = "f-" + Math.random().toString(36).substring(6) + ".gcode"
    await this.write(startMessage, this.modes.FILE_START, 0, startMessage.length)
    

    // send file + end
    let byteSize = this.packetSize - this.packetOverheadSize
    var re = new RegExp(`(.|[\r\n]){1,${byteSize}}`, 'g');

    // console.log(file)
    let packets = responseBody.match(re)
    
  
    for (let packetIndex = 0; packetIndex < packets.length; packetIndex++) {
      console.log("[FILE] Sending packet: " + packetIndex + " of " + packets.length)
      if (packetIndex === 0 && packets.length === 1) {
        await this.write(packets[packetIndex], this.modes.FILE_END, 0, packets[packetIndex].length)
      } else if (packetIndex === packets.length - 1) {
        await this.write(packets[packetIndex], this.modes.FILE_END, 0, packets[packetIndex].length)
      } else {
        await this.write(packets[packetIndex], this.modes.FILE_CONTINUE, 0, byteSize)
      }
    }

    console.log("[FILE] Sent file successfully")

    return startMessage
  }

  async sendMessage(command) {
    console.log("[COMMAND] Starting to send command")
    let byteSize = this.packetSize - this.packetOverheadSize
    var re = new RegExp(`.{1,${byteSize}}`, 'g');
    let packets = command.match(re)
    for (let packetIndex = 0; packetIndex < packets.length; packetIndex++) {
      console.log("[COMMAND] Sending packet: " + packetIndex + " of " + (packets.length - 1))
      if (packetIndex === 0 && packets.length === 1) {
        await this.write(packets[packetIndex], this.modes.COMMAND_FULL, 0, packets[packetIndex].length)
      } else if (packetIndex === 0) {
        await this.write(packets[packetIndex], this.modes.COMMAND_START, 0, byteSize)
      } else if (packetIndex === packets.length - 1) {
        await this.write(packets[packetIndex], this.modes.COMMAND_END, 0, packets[packetIndex].length)
      } else {
        await this.write(packets[packetIndex], this.modes.COMMAND_CONTINUE, 0, byteSize)
      }
    }
    console.log("[COMMAND] Sent command successfully")
  }

}

export default SerialManager;
